<template>
  <Layout>
  <DsIslandsContainer>
    <DsIsland align-center>
      <DsResultBanner
        class="w-full"
        type="neutral"
        size="small"
      >
      <template #title>
        <span v-html="debtsTypeText"></span>
      </template>
      </DsResultBanner>
    </DsIsland>
    <DsIsland v-if="!isTaxDebt">
      <DsTitle size="h2">
        <span v-html="hints.title" />
      </DsTitle>
      <DsStepper :progress="-1" :steps="2">
        <template v-slot:step-1>
          <div v-html="hints.items[0].text" />
          <DsButton class="mt-spacing-400" @click="sendAnalytic" type="tinted" icon="system/phone-400" size="small">1414</DsButton>
        </template>
        <template v-slot:step-2>
          <div v-html="hints.items[1].text" />
        </template>
      </DsStepper>
    </DsIsland>
    <DsButtonBar sticky>
      <DsButton v-if="isTaxDebt" @click.prevent="redirectToTaxPages" size="large">
        {{ translate('debts:btn') }}
      </DsButton>
      <DsButton :type="isTaxDebt ? 'ghost' : 'primary'" size="large" @click="goHome">
          {{ translate('debts:back-to-main') }}
      </DsButton>
    </DsButtonBar>
  </DsIslandsContainer>
  </Layout>
</template>

<script setup>
import { DsIsland,DsIslandsContainer, DsTitle, DsStepper, DsResultBanner, DsButtonBar, DsButton } from '@ds/vue2'
import translate from "@/filters/translate.filter"
import { eventBus } from 'kaspi.frontend/src/modules/eventBus/eventBus'
import * as debtsTypes from './debtsTypes'
import { sendAnalyticEvent } from '@/helpers/sendAnalyticEvent'
import {ref, computed, onMounted} from 'vue'

import useStore from '@/composables/useStore'
import useHeader from '@/composables/useHeader'
import { getDeviceType } from '@/helpers/getDeviceType'
import Layout from '@/components/ui/Layout/Layout.vue'
const store = useStore()
const {hideBackBtn} = useHeader()
hideBackBtn()

const hints =  ref({
  title: translate('debts:title-how'),
  items: [
    {
      text: translate('debts:hint-1'),
      key: 'phone'
    },
    {
      text: translate('debts:hint-2')
    }
  ]
})
const data =  ref({
  hasDebts: false,
  debtsTypeString: '',
  taxDebt: '',
  socialDebt: '',
  totalDebts: ''
})
const isIos = () => {
  return getDeviceType() === 'ios'
}
const debtsTypeText = computed(() => {
  switch (data.value.debtsTypeString) {
    case debtsTypes.SOCIAL_DEBTS:
      return translate('debts:social-debts', formattedNumber(data.value.socialDebt))
    case debtsTypes.TAX_DEBTS:
      return translate('debts:tax-debts', formattedNumber(data.value.taxDebt))
    case debtsTypes.TAX_AND_SOCIAL_DEBTS:
      return translate('debts:tax-and-social-debts', formattedNumber(data.value.taxDebt), formattedNumber(data.value.socialDebt))
    default:
      return translate('debts:undefined')
  }
})

const redirectToTaxPages = () => {
  window.location.href = process.env.VUE_APP_BASE_URL + '/pay/government/governmentP/TaxesDebts'
}
const goHome = () => {
  window.location.href = process.env.VUE_APP_BASE_URL
}
const dataStep = async () => {
  const response = await store.dispatch('goldkidProcess/dataStep')

  data.value = { ...response?.data?.data }
}
const isTaxDebt = computed(() => {
  return data.value.debtsTypeString === debtsTypes.TAX_DEBTS
})
const formattedNumber = (number) => {
  return (Number(number)).toLocaleString('ru-RU')
}
const sendAnalytic = () => {
  sendAnalyticEvent('online_child_gold_call_center_click', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    inner_source: ['online_child_gold_debts'],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
  window.location.href='tel:1414'
}

onMounted(async () => {
  await dataStep()
  eventBus.$emit('kaspiLoading', false)
  sendAnalyticEvent('online_child_gold_debts', {
    started_from: [store.getters['app/urlParams'].startedFrom],
    stage: ['start'],
    reject_reason: [data.value.debtsTypeString],
    page_path: ['/bank/bpm/products/goldkids/goldkid'],
    external_message_id: [store.getters['goldkidProcess/pId']]
  })
})

</script>
